import { render } from "./PremiumFeatures.vue?vue&type=template&id=7d16807f&scoped=true"
import script from "./PremiumFeatures.vue?vue&type=script&lang=js"
export * from "./PremiumFeatures.vue?vue&type=script&lang=js"

import "./PremiumFeatures.vue?vue&type=style&index=0&id=7d16807f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d16807f"]])

export default __exports__